<template>
	<table>
		<PatientRowHead :active-columns="activeColumns"></PatientRowHead>
		<tbody>
			<PatientRow v-for="(patient, index) in patients"
				:key="'' + index"
				:first="index == 0"
				:active-columns="activeColumns"
				:show-error="showError"
				v-bind:enrolling="enrolling"
				v-model="patient.data"
				@remove="removeRow(index)">
			</PatientRow>
			<tr>
				<td class="add-row" colspan="4">
					<button class="btn btn-link"
						@click="addRow">
						<AddRowIcon></AddRowIcon>
						Add another
					</button>

				</td>
			</tr>
		</tbody>
	</table>
</template>
<script>
import PatientList from './mixin/patient-list'
import PatientRowHead from '../head/Patient'
import PatientRow from '../row/Patient'
import AddRowIcon from '../icons/AddRow'

export default {
	name: 'patient-form-table',
	mixins: [ PatientList ],
	props: [ 
		'enrolling',
		'importing',
		// Show error in form in manual import
		'showError'
		],

	components: {
		PatientRowHead,
		PatientRow,
		AddRowIcon,
	}
}
</script>
<style lang="scss" scoped>
@import "style.scss";
table {
	table-layout: fixed;
}
</style>
